import { ReportExecutionOrder } from "../../../types/ReportExecutionOrder";

export const addProcedureDefinitionToList = (
  list: ReportExecutionOrder[],
  procedureDefinition: ReportExecutionOrder
): ReportExecutionOrder[] => {
  return [...list, procedureDefinition];
};

export const removeProcedureDefinitionFromList = (
  list: ReportExecutionOrder[],
  procedureDefinition: ReportExecutionOrder
): ReportExecutionOrder[] => {
  return list.filter(
    (existingProcedureDefinition) =>
      existingProcedureDefinition !== procedureDefinition
  );
};
